import React from 'react';
import PropTypes from 'prop-types';
import ModalService from 'ui-components/services/modal-service';

const asModal = (WrappedComponent) => {
  const AsModal = class extends React.PureComponent {
    componentDidMount() {
      if (!this.modalId) {
        this.modalId = this.launchModal();
      }
    }

    componentDidUpdate() {
      if (!this.modalId) {
        return;
      }
      ModalService.updateModalById(this.modalId, this.buildModalRequest());
    }

    componentWillUnmount() {
      const { modalId } = this;
      if (modalId) {
        ModalService.closeModalById(modalId);
        this.modalId = undefined;
      }
    }

    buildModalRequest = () => {
      const { onClose, onCancel } = this.props;
      return {
        component: WrappedComponent,
        onClose,
        onCancel: onCancel ?? onClose,
        props: this.props,
      };
    };

    launchModal = () => {
      return ModalService.launchModal(this.buildModalRequest());
    };

    render() {
      // returning nothing here because we render
      //   the component inside the modal
      return null;
    }
  };

  AsModal.propTypes = {
    onClose: PropTypes.func,
    onCancel: PropTypes.func,
  };

  AsModal.displayName = `AsModal(${WrappedComponent.displayName})`;

  return AsModal;
};

export default asModal;
